import React from 'react'
import { Redirect, Route, Router, Switch } from 'react-router-dom'

import App from './App'
import { AuthGate } from './components/AuthGate'
import { AuthCallbackRoute } from './components/Callback/AuthCallbackRoute'

import history from './history'
import auth from './auth/service'
import { getLoginReferrer } from './auth/loginReferrer'

export const makeMainRoutes = () => {
  return (
    <Router history={history}>
      <Switch>
        <Route
          path="/login"
          render={(props) => {
            auth.login(getLoginReferrer(props.location))
            return null
          }}
        />
        <Route
          path="/callback"
          render={(props) => {
            return <AuthCallbackRoute {...props} />
          }}
        />
        <Route
          path="/"
          render={(props) => {
            return (
              <AuthGate {...props}>
                <App {...props} />
              </AuthGate>
            )
          }}
        />
        <Route
          path="/"
          render={(props) => { 
            return <Redirect
              to={{
                pathname: '/',
                state: {
                  referrer: props.location.pathname + props.location.search,
                },
              }}
            />
            }}
          />
        {/*<Route
          path="/reporting"
          render={props => {
            return !auth.isAuthenticated() ? (
              <Redirect
                to={{
                  pathname: '/login',
                  state: {
                    referrer: props.location.pathname + props.location.search
                  }
                }}
              />
            ) : (
              <AppTaggingTool {...props} />
            )
          }}
        />*/}
      </Switch>
    </Router>
  )
}
